import React from "react";

const NeccInner = () => {
  return (
    <>
      {/* Start Services area  */}
      <div className='service-area pd-top-45 pd-bottom-45 '>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-11 align-self-center'>
                <div className='about-inner-wrap'>
                  <div className='section-title mb-0'>
                <h2 className='title'>North Eastern Carrying Corporation</h2>
             
                  <p className='content'>
                  When we talk about domestic shipping, it is very large industry with plenty of options for a business owner. Also, it becomes very tough to choose a reliable carrier for businesses. North Eastern Carrying Corporation works is a multi-modal company specialized in providing services in Road, Rail and Air Freight. We are very professional and experienced committed to offer cargo transportation in a safe, cost-effective and time bound manner.
                    </p>
          
                <p className='content'>
                Since our inception, we are engaged in providing reliable and specialized services to our various clients. Full Truck Load (FTL) transportation is our quality and main concern. Full truck loading provided by us is time bound and covers major areas in India, Nepal and Bhutan. Our freight management is extraordinary as compared to our competitors. We leverage our operational expertise, technology and high capacity network to offer our customers end-to-end supply chain solutions.
                </p>
                <p className='content'>
                Today, North Eastern Carrying Corporation has a team of dedicated workforce of over 1500 professionally trained employees and branches at strategic locations. Our work policy is very simple; we work on the basis of close co-ordination & excellent team work which ensures prompt and satisfactory cargo movement throughout India and in neighboring countries.
                </p>
                <p className='content'>When it comes to goods transportation and logistics services, we are the best service provider and expert in National transportation services. Transport for Nepal and Bhutan has become very cost-effective and reliable through our hard work and time bound services. Nationwide transport services offered by our team are exceptional and tracked by advanced software’s and expert professionals. We never compromise with the quality and make sure your consignments reach on time.</p>

          <h4 style={{marginTop:"20px",marginBottom:"20px"}}>A Glimpse at our Transport Related Services</h4>
                <div className='row'>
                      <div className='col-xl-6 col-lg-12 col-md-6'>
                        <ul className='list-inner-wrap mb-mb-0 mb-3 mb-lg-3 mb-xl-0'>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />{" "}
                           Small consignments retail booking
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            Full truck load services.
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            Storage facility
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            PTL/Parcel load movement
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                           Over dimensional consignment
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            Containerized movement of cargo
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            Freight Management
                          </li>
                        </ul>
                      </div>
                    </div>
                 </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      {/* End Services area  */}
    </>
  );
};

export default NeccInner;
